export type { Mask } from './use-input-mask';
export { default } from './use-input-mask';
